export enum ETriggerFrequency {
  Once = '1',
  EveryHour = '2',
  EveryDay = '3',
  EveryWeek = '4',
  EveryMonth = '5',
  EveryYear = '6'
}
export const TRIGGER_FREQUENCY_LABEL: {
  [trigger in keyof typeof ETriggerFrequency]: string;
} = {
  Once: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_ONCE:Once`,
  EveryHour: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_HOUR:Every Hour`,
  EveryDay: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_DAY:Every Day`,
  EveryWeek: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_WEEK:Every Week`,
  EveryMonth: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_MONTH:Every Month`,
  EveryYear: $localize`:@@DASHBOARD_SCENES_EDITOR_TIME_TRIGGER_YEAR:Every Year`
};
